// // import MDBox from "components/MDBox";
// // import MDTypography from "components/MDTypography";
// // import {
// //   Box,
// //   Dialog,
// //   TextField,
// //   Grid,
// //   DialogTitle,
// //   Paper,
// // } from "@mui/material";

// // // Icon libraries
// // import * as GiIcons from "react-icons/gi";
// // import * as MdIcons from "react-icons/md";
// // import * as FaIcons from "react-icons/fa";
// // import * as BiIcons from "react-icons/bi";
// // import * as RiIcons from "react-icons/ri";

// // import { useState, useMemo } from "react";
// // import { ICON_OPTIONS } from "./icon";

// // const ICON_LIBRARIES = {
// //   GI: GiIcons,
// //   MD: MdIcons,
// //   FA: FaIcons,
// //   BI: BiIcons,
// //   RI: RiIcons,
// // };

// // function IconPicker({ changeHandler, icon }) {
// //   const [openIconDialog, setOpenIconDialog] = useState(false);
// //   const [searchTerm, setSearchTerm] = useState("");

// //   const handleSelectIcon = (iconName) => {
// //     changeHandler(iconName);
// //     setOpenIconDialog(false);
// //     setSearchTerm("");
// //   };

// //   // Filter out icons that don't exist in the libraries
// //   const validatedIcons = useMemo(() => {
// //     return ICON_OPTIONS.filter((icon) => {
// //       const prefix = icon.prefix.toUpperCase();
// //       const IconComponent = ICON_LIBRARIES[prefix]?.[icon.name];
// //       return !!IconComponent; // Only keep icons that exist
// //     });
// //   }, []);

// //   const getIconComponent = (iconName) => {
// //     if (!iconName) return null;
// //     const prefix = iconName.substring(0, 2).toUpperCase();
// //     const IconComponent = ICON_LIBRARIES[prefix]?.[iconName];
// //     return IconComponent ? <IconComponent size={48} /> : null;
// //   };

// //   // Filter icons based on search term AND existence
// //   const filteredIcons = useMemo(() => {
// //     let icons = validatedIcons;
// //     if (!searchTerm) return icons;
// //     const lowerSearch = searchTerm.toLowerCase();
// //     return icons.filter(
// //       (icon) =>
// //         icon.label.toLowerCase().includes(lowerSearch) ||
// //         icon.name.toLowerCase().includes(lowerSearch)
// //     );
// //   }, [searchTerm, validatedIcons]);

// //   return (
// //     <MDBox>
// //       <Dialog
// //         open={openIconDialog}
// //         onClose={() => setOpenIconDialog(false)}
// //         maxWidth="md"
// //         fullWidth
// //       >
// //         <DialogTitle>Select Icon</DialogTitle>

// //         {/* Search Input */}
// //         <MDBox sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
// //           <TextField
// //             fullWidth
// //             placeholder="Search icons (e.g., water, heart, charity)..."
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //             size="small"
// //             variant="outlined"
// //           />
// //           <MDTypography
// //             variant="caption"
// //             color="secondary"
// //             sx={{ mt: 1, display: "block" }}
// //           >
// //             Found: {filteredIcons.length} icons
// //           </MDTypography>
// //         </MDBox>

// //         {/* Icons Grid */}
// //         <Box sx={{ p: 2, maxHeight: 500, overflow: "auto" }}>
// //           {filteredIcons.length > 0 ? (
// //             <Grid container spacing={1}>
// //               {filteredIcons.map((iconData) => {
// //                 const prefix = iconData.prefix.toUpperCase();
// //                 const IconComponent = ICON_LIBRARIES[prefix]?.[iconData.name];

// //                 // Skip if icon doesn't exist
// //                 if (!IconComponent) return null;

// //                 return (
// //                   <Grid item xs={6} sm={4} md={3} key={iconData.name}>
// //                     <Paper
// //                       onClick={() => handleSelectIcon(iconData.name)}
// //                       sx={{
// //                         p: 2,
// //                         textAlign: "center",
// //                         cursor: "pointer",
// //                         transition: "all 0.2s",
// //                         border:
// //                           icon === iconData.name
// //                             ? "2px solid #ff6b35"
// //                             : "1px solid #e0e0e0",
// //                         backgroundColor:
// //                           icon === iconData.name ? "#fff5f1" : "transparent",
// //                         "&:hover": {
// //                           borderColor: "#ff6b35",
// //                           backgroundColor: "#fff5f1",
// //                           transform: "translateY(-4px)",
// //                           boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
// //                         },
// //                       }}
// //                     >
// //                       <Box sx={{ fontSize: "32px", mb: 1 }}>
// //                         {IconComponent && <IconComponent />}
// //                       </Box>
// //                       <MDTypography
// //                         variant="caption"
// //                         sx={{ display: "block", wordBreak: "break-word" }}
// //                       >
// //                         {iconData.label}
// //                       </MDTypography>
// //                       <MDTypography
// //                         variant="caption"
// //                         color="secondary"
// //                         sx={{ fontSize: "10px" }}
// //                       >
// //                         {iconData.name}
// //                       </MDTypography>
// //                     </Paper>
// //                   </Grid>
// //                 );
// //               })}
// //             </Grid>
// //           ) : (
// //             <MDBox textAlign="center" py={4}>
// //               <MDTypography variant="body2" color="secondary">
// //                 No icons found. Try a different search.
// //               </MDTypography>
// //             </MDBox>
// //           )}
// //         </Box>
// //       </Dialog>

// //       {/* Icon Preview Box */}
// //       <MDTypography variant="subtitle2" mb={1}>
// //         Select Icon
// //       </MDTypography>
// //       <Box
// //         sx={{
// //           border: "2px dashed #e0e0e0",
// //           borderRadius: 2,
// //           p: 3,
// //           textAlign: "center",
// //           cursor: "pointer",
// //           transition: "all 0.3s",
// //           "&:hover": {
// //             borderColor: "#ff6b35",
// //             backgroundColor: "#fff5f1",
// //           },
// //         }}
// //         onClick={() => setOpenIconDialog(true)}
// //       >
// //         <Box sx={{ fontSize: "48px", mb: 1 }}>
// //           {getIconComponent(icon || "GiWaterDrop")}
// //         </Box>
// //         <MDTypography variant="button" color="info">
// //           Click to select icon
// //         </MDTypography>
// //         <MDTypography
// //           variant="caption"
// //           color="secondary"
// //           display="block"
// //           sx={{ mt: 1 }}
// //         >
// //           Current: {icon || "Not selected"}
// //         </MDTypography>
// //       </Box>
// //     </MDBox>
// //   );
// // }

// // export default IconPicker;

// // components/IconPicker.js
// import React, { useState, useEffect, useRef } from "react";
// import { Icon } from "@iconify/react";

// // Material UI components
// import {
//   TextField,
//   InputAdornment,
//   Box,
//   Grid,
//   Paper,
//   IconButton,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   Button,
//   InputBase,
//   Typography,
//   Tabs,
//   Tab,
//   Chip,
//   FormControlLabel,
//   Switch,
//   Tooltip,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import CloseIcon from "@mui/icons-material/Close";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import StarIcon from "@mui/icons-material/Star";
// import CategoryIcon from "@mui/icons-material/Category";
// import RecentIcon from "@mui/icons-material/History";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import GridViewIcon from "@mui/icons-material/GridView";
// import ListIcon from "@mui/icons-material/List";
// import MDBox from "components/MDBox";
// import { ICONS_BY_CATEGORY } from "./icon";

// // Get all icons for search
// export const ALL_ICONS = Object.values(ICONS_BY_CATEGORY).flat();

// // Categories for tabs
// export const CATEGORIES = [
//   { id: "all", label: "الكل", count: ALL_ICONS.length },
//   {
//     id: "islamic",
//     label: "إسلامي",
//     count: ICONS_BY_CATEGORY.islamic.length,
//     icon: "mdi:mosque",
//   },
//   {
//     id: "donation",
//     label: "التبرعات",
//     count: ICONS_BY_CATEGORY.donation.length,
//     icon: "mdi:heart",
//   },
//   {
//     id: "organization",
//     label: "المؤسسة",
//     count: ICONS_BY_CATEGORY.organization.length,
//     icon: "mdi:office-building",
//   },
//   {
//     id: "finance",
//     label: "المالية",
//     count: ICONS_BY_CATEGORY.finance.length,
//     icon: "mdi:cash",
//   },
//   {
//     id: "social",
//     label: "التواصل",
//     count: ICONS_BY_CATEGORY.social.length,
//     icon: "mdi:share",
//   },
//   {
//     id: "contact",
//     label: "الاتصال",
//     count: ICONS_BY_CATEGORY.contact.length,
//     icon: "mdi:phone",
//   },
//   {
//     id: "location",
//     label: "الموقع",
//     count: ICONS_BY_CATEGORY.location.length,
//     icon: "mdi:map-marker",
//   },
//   {
//     id: "ui",
//     label: "واجهة",
//     count: ICONS_BY_CATEGORY.ui.length,
//     icon: "mdi:menu",
//   },
//   {
//     id: "documents",
//     label: "المستندات",
//     count: ICONS_BY_CATEGORY.documents.length,
//     icon: "mdi:file-document",
//   },
//   {
//     id: "media",
//     label: "الوسائط",
//     count: ICONS_BY_CATEGORY.media.length,
//     icon: "mdi:image",
//   },
//   {
//     id: "people",
//     label: "الأشخاص",
//     count: ICONS_BY_CATEGORY.people.length,
//     icon: "mdi:account-group",
//   },
//   {
//     id: "food",
//     label: "الغذاء",
//     count: ICONS_BY_CATEGORY.food.length,
//     icon: "mdi:food",
//   },
//   {
//     id: "education",
//     label: "التعليم",
//     count: ICONS_BY_CATEGORY.education.length,
//     icon: "mdi:school",
//   },
//   {
//     id: "transportation",
//     label: "النقل",
//     count: ICONS_BY_CATEGORY.transportation.length,
//     icon: "mdi:car",
//   },
//   {
//     id: "health",
//     label: "الصحة",
//     count: ICONS_BY_CATEGORY.health.length,
//     icon: "mdi:medical-bag",
//   },
//   {
//     id: "prayer",
//     label: "الصلاة",
//     count: ICONS_BY_CATEGORY.prayer.length,
//     icon: "mdi:pray",
//   },
//   {
//     id: "calendar",
//     label: "التقويم",
//     count: ICONS_BY_CATEGORY.calendar.length,
//     icon: "mdi:calendar",
//   },
//   {
//     id: "weather",
//     label: "الطقس",
//     count: ICONS_BY_CATEGORY.weather.length,
//     icon: "mdi:weather-sunny",
//   },
//   {
//     id: "security",
//     label: "الأمان",
//     count: ICONS_BY_CATEGORY.security.length,
//     icon: "mdi:shield",
//   },
// ];

// const IconPicker = ({
//   value,
//   onChange,
//   label = "اختر أيقونة",
//   error,
//   helperText,
//   width = "100%",
//   size = "medium",
// }) => {
//   const [open, setOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredIcons, setFilteredIcons] = useState(ALL_ICONS);
//   const [activeCategory, setActiveCategory] = useState("all");
//   const [favorites, setFavorites] = useState([]);
//   const [viewMode, setViewMode] = useState("grid"); // 'grid' or 'list'
//   const [showNames, setShowNames] = useState(true);
//   const [recentIcons, setRecentIcons] = useState([]);
//   const searchRef = useRef(null);

//   // Load favorites and recent from localStorage
//   useEffect(() => {
//     const savedFavorites = localStorage.getItem("iconFavorites");
//     const savedRecent = localStorage.getItem("iconRecent");

//     if (savedFavorites) {
//       setFavorites(JSON.parse(savedFavorites));
//     }

//     if (savedRecent) {
//       setRecentIcons(JSON.parse(savedRecent));
//     }
//   }, []);

//   // Save to localStorage
//   useEffect(() => {
//     localStorage.setItem("iconFavorites", JSON.stringify(favorites));
//   }, [favorites]);

//   useEffect(() => {
//     localStorage.setItem("iconRecent", JSON.stringify(recentIcons));
//   }, [recentIcons]);

//   // Filter icons based on search and category
//   useEffect(() => {
//     let iconsToFilter = ALL_ICONS;

//     if (activeCategory !== "all" && ICONS_BY_CATEGORY[activeCategory]) {
//       iconsToFilter = ICONS_BY_CATEGORY[activeCategory];
//     }

//     if (searchTerm.trim() === "") {
//       setFilteredIcons(iconsToFilter);
//     } else {
//       const filtered = iconsToFilter.filter((icon) =>
//         icon.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setFilteredIcons(filtered);
//     }
//   }, [searchTerm, activeCategory]);

//   const handleOpen = () => {
//     setOpen(true);
//     setSearchTerm("");
//     setActiveCategory("all");
//     setTimeout(() => {
//       if (searchRef.current) {
//         searchRef.current.focus();
//       }
//     }, 100);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleSelectIcon = (icon) => {
//     // Add to recent
//     const newRecent = [icon, ...recentIcons.filter((i) => i !== icon)].slice(
//       0,
//       10
//     );
//     setRecentIcons(newRecent);

//     onChange(icon);
//     handleClose();
//   };

//   const handleClear = () => {
//     onChange("");
//   };

//   const toggleFavorite = (icon, e) => {
//     e.stopPropagation();
//     if (favorites.includes(icon)) {
//       setFavorites(favorites.filter((fav) => fav !== icon));
//     } else {
//       setFavorites([...favorites, icon]);
//     }
//   };

//   const handleCategoryChange = (categoryId) => {
//     setActiveCategory(categoryId);
//     setSearchTerm("");
//   };

//   const addToRecent = (icon) => {
//     const newRecent = [icon, ...recentIcons.filter((i) => i !== icon)].slice(
//       0,
//       12
//     );
//     setRecentIcons(newRecent);
//   };

//   return (
//     <>
//       <MDBox width={width}>
//         <TextField
//           fullWidth
//           label={label}
//           value={value}
//           onClick={handleOpen}
//           error={error}
//           helperText={helperText}
//           InputProps={{
//             readOnly: true,
//             startAdornment: value ? (
//               <InputAdornment position="start">
//                 <Icon
//                   icon={value}
//                   width={size === "small" ? 20 : 24}
//                   height={size === "small" ? 20 : 24}
//                 />
//               </InputAdornment>
//             ) : null,
//             endAdornment: (
//               <InputAdornment position="end">
//                 {value ? (
//                   <IconButton size="small" onClick={handleClear}>
//                     <CloseIcon fontSize="small" />
//                   </IconButton>
//                 ) : (
//                   <IconButton size="small" onClick={handleOpen}>
//                     <SearchIcon />
//                   </IconButton>
//                 )}
//               </InputAdornment>
//             ),
//           }}
//           size={size}
//           sx={{
//             cursor: "pointer",
//             "& .MuiInputBase-input": {
//               cursor: "pointer",
//             },
//           }}
//         />
//       </MDBox>

//       <Dialog
//         open={open}
//         onClose={handleClose}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           sx: {
//             height: "85vh",
//             maxHeight: "800px",
//             borderRadius: 2,
//           },
//         }}
//       >
//         <DialogTitle sx={{ pb: 1 }}>
//           <MDBox
//             display="flex"
//             justifyContent="space-between"
//             alignItems="center"
//           >
//             <Typography
//               variant="h6"
//               sx={{ display: "flex", alignItems: "center", gap: 1 }}
//             >
//               <GridViewIcon />
//               محدد الأيقونات
//             </Typography>
//             <MDBox display="flex" gap={1} alignItems="center">
//               <Tooltip title="عرض الأسماء">
//                 <FormControlLabel
//                   control={
//                     <Switch
//                       size="small"
//                       checked={showNames}
//                       onChange={(e) => setShowNames(e.target.checked)}
//                     />
//                   }
//                   label=""
//                 />
//               </Tooltip>
//               <Tooltip title="عرض شبكة">
//                 <IconButton
//                   size="small"
//                   color={viewMode === "grid" ? "primary" : "default"}
//                   onClick={() => setViewMode("grid")}
//                 >
//                   <GridViewIcon />
//                 </IconButton>
//               </Tooltip>
//               <Tooltip title="عرض قائمة">
//                 <IconButton
//                   size="small"
//                   color={viewMode === "list" ? "primary" : "default"}
//                   onClick={() => setViewMode("list")}
//                 >
//                   <ListIcon />
//                 </IconButton>
//               </Tooltip>
//               <IconButton onClick={handleClose} size="small">
//                 <CloseIcon />
//               </IconButton>
//             </MDBox>
//           </MDBox>

//           <MDBox mt={2}>
//             <InputBase
//               fullWidth
//               placeholder="ابحث عن أيقونة (مثال: heart, home, phone)..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               inputRef={searchRef}
//               startAdornment={
//                 <InputAdornment position="start">
//                   <SearchIcon />
//                 </InputAdornment>
//               }
//               sx={{
//                 bgcolor: "background.paper",
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1.5,
//                 border: "2px solid",
//                 borderColor: "primary.light",
//                 "&:focus-within": {
//                   borderColor: "primary.main",
//                 },
//               }}
//             />
//           </MDBox>

//           {/* Categories Tabs */}
//           <MDBox mt={2} sx={{ overflowX: "auto", pb: 1 }}>
//             <MDBox display="flex" gap={0.5} sx={{ minWidth: "max-content" }}>
//               {CATEGORIES.map((category) => (
//                 <Chip
//                   key={category.id}
//                   label={`${category.label} (${category.count})`}
//                   onClick={() => handleCategoryChange(category.id)}
//                   color={activeCategory === category.id ? "primary" : "default"}
//                   variant={
//                     activeCategory === category.id ? "filled" : "outlined"
//                   }
//                   icon={
//                     category.icon ? (
//                       <Icon icon={category.icon} width={16} height={16} />
//                     ) : undefined
//                   }
//                   size="small"
//                   sx={{
//                     borderRadius: 1.5,
//                     fontWeight:
//                       activeCategory === category.id ? "bold" : "normal",
//                   }}
//                 />
//               ))}
//             </MDBox>
//           </MDBox>
//         </DialogTitle>

//         <DialogContent dividers sx={{ p: 2 }}>
//           {/* Recent Icons */}
//           {recentIcons.length > 0 &&
//             activeCategory === "all" &&
//             searchTerm === "" && (
//               <MDBox mb={3}>
//                 <Typography
//                   variant="subtitle1"
//                   gutterBottom
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 1,
//                     color: "primary.main",
//                   }}
//                 >
//                   <RecentIcon fontSize="small" />
//                   <span>الأيقونات المستخدمة مؤخراً</span>
//                 </Typography>
//                 <Grid container spacing={1}>
//                   {recentIcons.map((icon) => (
//                     <Grid item xs={viewMode === "grid" ? 2 : 12} key={icon}>
//                       <Paper
//                         elevation={value === icon ? 3 : 1}
//                         sx={{
//                           p: viewMode === "grid" ? 1.5 : 1,
//                           display: "flex",
//                           flexDirection: viewMode === "grid" ? "column" : "row",
//                           alignItems: "center",
//                           justifyContent:
//                             viewMode === "grid" ? "center" : "flex-start",
//                           cursor: "pointer",
//                           height: "100%",
//                           minHeight: viewMode === "grid" ? "70px" : "auto",
//                           border: value === icon ? "2px solid" : "1px solid",
//                           borderColor:
//                             value === icon ? "primary.main" : "divider",
//                           bgcolor:
//                             value === icon
//                               ? "primary.light"
//                               : "background.paper",
//                           "&:hover": {
//                             bgcolor: "action.hover",
//                             transform: "scale(1.02)",
//                             transition: "transform 0.2s",
//                           },
//                           gap: viewMode === "list" ? 2 : 0,
//                         }}
//                         onClick={() => handleSelectIcon(icon)}
//                       >
//                         <MDBox
//                           position="relative"
//                           display="flex"
//                           alignItems="center"
//                         >
//                           <Icon
//                             icon={icon}
//                             width={viewMode === "grid" ? 20 : 24}
//                             height={viewMode === "grid" ? 20 : 24}
//                           />
//                           <IconButton
//                             size="small"
//                             onClick={(e) => toggleFavorite(icon, e)}
//                             sx={{
//                               position:
//                                 viewMode === "grid" ? "absolute" : "relative",
//                               top: viewMode === "grid" ? -8 : 0,
//                               right: viewMode === "grid" ? -8 : 0,
//                               bgcolor: "background.paper",
//                               width: 20,
//                               height: 20,
//                               opacity: 0.8,
//                               "&:hover": {
//                                 opacity: 1,
//                               },
//                             }}
//                           >
//                             {favorites.includes(icon) ? (
//                               <StarIcon fontSize="small" color="warning" />
//                             ) : (
//                               <StarIcon fontSize="small" />
//                             )}
//                           </IconButton>
//                         </MDBox>
//                         {showNames && (
//                           <MDBox
//                             textAlign={viewMode === "grid" ? "center" : "left"}
//                             flex={1}
//                           >
//                             <Typography
//                               variant="caption"
//                               sx={{
//                                 display: "block",
//                                 wordBreak: "break-word",
//                                 fontSize:
//                                   viewMode === "grid" ? "0.55rem" : "0.75rem",
//                                 fontWeight:
//                                   viewMode === "list" ? "medium" : "normal",
//                               }}
//                             >
//                               {icon.split(":").pop()}
//                             </Typography>
//                             {viewMode === "list" && (
//                               <Typography
//                                 variant="caption"
//                                 color="text.secondary"
//                                 sx={{
//                                   fontSize: "0.65rem",
//                                 }}
//                               >
//                                 {icon}
//                               </Typography>
//                             )}
//                           </MDBox>
//                         )}
//                       </Paper>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </MDBox>
//             )}

//           {/* Favorites */}
//           {favorites.length > 0 &&
//             activeCategory === "all" &&
//             searchTerm === "" && (
//               <MDBox mb={3}>
//                 <Typography
//                   variant="subtitle1"
//                   gutterBottom
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 1,
//                     color: "warning.main",
//                   }}
//                 >
//                   <StarIcon fontSize="small" />
//                   <span>المفضلة ({favorites.length})</span>
//                 </Typography>
//                 <Grid container spacing={1}>
//                   {favorites.map((icon) => (
//                     <Grid item xs={viewMode === "grid" ? 2 : 12} key={icon}>
//                       <Paper
//                         elevation={value === icon ? 3 : 1}
//                         sx={{
//                           p: viewMode === "grid" ? 1.5 : 1,
//                           display: "flex",
//                           flexDirection: viewMode === "grid" ? "column" : "row",
//                           alignItems: "center",
//                           justifyContent:
//                             viewMode === "grid" ? "center" : "flex-start",
//                           cursor: "pointer",
//                           height: "100%",
//                           minHeight: viewMode === "grid" ? "70px" : "auto",
//                           border: value === icon ? "2px solid" : "1px solid",
//                           borderColor:
//                             value === icon ? "primary.main" : "divider",
//                           bgcolor:
//                             value === icon
//                               ? "primary.light"
//                               : "background.paper",
//                           "&:hover": {
//                             bgcolor: "action.hover",
//                             transform: "scale(1.02)",
//                             transition: "transform 0.2s",
//                           },
//                           gap: viewMode === "list" ? 2 : 0,
//                         }}
//                         onClick={() => handleSelectIcon(icon)}
//                       >
//                         <MDBox
//                           position="relative"
//                           display="flex"
//                           alignItems="center"
//                         >
//                           <Icon
//                             icon={icon}
//                             width={viewMode === "grid" ? 20 : 24}
//                             height={viewMode === "grid" ? 20 : 24}
//                           />
//                           <IconButton
//                             size="small"
//                             onClick={(e) => toggleFavorite(icon, e)}
//                             sx={{
//                               position:
//                                 viewMode === "grid" ? "absolute" : "relative",
//                               top: viewMode === "grid" ? -8 : 0,
//                               right: viewMode === "grid" ? -8 : 0,
//                               bgcolor: "background.paper",
//                               width: 20,
//                               height: 20,
//                               opacity: 0.8,
//                               "&:hover": {
//                                 opacity: 1,
//                               },
//                             }}
//                           >
//                             <StarIcon fontSize="small" color="warning" />
//                           </IconButton>
//                         </MDBox>
//                         {showNames && (
//                           <MDBox
//                             textAlign={viewMode === "grid" ? "center" : "left"}
//                             flex={1}
//                           >
//                             <Typography
//                               variant="caption"
//                               sx={{
//                                 display: "block",
//                                 wordBreak: "break-word",
//                                 fontSize:
//                                   viewMode === "grid" ? "0.55rem" : "0.75rem",
//                                 fontWeight:
//                                   viewMode === "list" ? "medium" : "normal",
//                               }}
//                             >
//                               {icon.split(":").pop()}
//                             </Typography>
//                             {viewMode === "list" && (
//                               <Typography
//                                 variant="caption"
//                                 color="text.secondary"
//                                 sx={{
//                                   fontSize: "0.65rem",
//                                 }}
//                               >
//                                 {icon}
//                               </Typography>
//                             )}
//                           </MDBox>
//                         )}
//                       </Paper>
//                     </Grid>
//                   ))}
//                 </Grid>
//               </MDBox>
//             )}

//           {/* Main Icons */}
//           <MDBox>
//             <Typography variant="subtitle1" gutterBottom>
//               {CATEGORIES.find((c) => c.id === activeCategory)?.label ||
//                 "جميع الأيقونات"}
//               <Typography
//                 component="span"
//                 color="text.secondary"
//                 sx={{ ml: 1 }}
//               >
//                 ({filteredIcons.length} أيقونة)
//               </Typography>
//             </Typography>

//             {viewMode === "grid" ? (
//               <Grid container spacing={1}>
//                 {filteredIcons.map((icon) => (
//                   <Grid item xs={3} sm={2} md={1.5} key={icon}>
//                     <Tooltip title={icon} placement="top">
//                       <Paper
//                         elevation={value === icon ? 3 : 1}
//                         sx={{
//                           p: 1.5,
//                           display: "flex",
//                           flexDirection: "column",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           cursor: "pointer",
//                           height: "100%",
//                           minHeight: "70px",
//                           border: value === icon ? "2px solid" : "1px solid",
//                           borderColor:
//                             value === icon ? "primary.main" : "divider",
//                           bgcolor:
//                             value === icon
//                               ? "primary.light"
//                               : "background.paper",
//                           "&:hover": {
//                             bgcolor: "action.hover",
//                             transform: "scale(1.05)",
//                             transition: "transform 0.2s",
//                             boxShadow: 3,
//                           },
//                         }}
//                         onClick={() => handleSelectIcon(icon)}
//                       >
//                         <MDBox position="relative">
//                           <Icon icon={icon} width={20} height={20} />
//                           <IconButton
//                             size="small"
//                             onClick={(e) => toggleFavorite(icon, e)}
//                             sx={{
//                               position: "absolute",
//                               top: -8,
//                               right: -8,
//                               bgcolor: "background.paper",
//                               width: 20,
//                               height: 20,
//                               opacity: 0,
//                               "&:hover": {
//                                 opacity: 1,
//                               },
//                               "&.MuiIconButton-root:hover": {
//                                 bgcolor: "background.paper",
//                               },
//                             }}
//                           >
//                             {favorites.includes(icon) ? (
//                               <StarIcon fontSize="small" color="warning" />
//                             ) : (
//                               <StarIcon fontSize="small" />
//                             )}
//                           </IconButton>
//                         </MDBox>
//                         {showNames && (
//                           <Typography
//                             variant="caption"
//                             sx={{
//                               mt: 0.5,
//                               textAlign: "center",
//                               wordBreak: "break-word",
//                               fontSize: "0.55rem",
//                               lineHeight: 1.2,
//                             }}
//                           >
//                             {icon.split(":").pop()}
//                           </Typography>
//                         )}
//                       </Paper>
//                     </Tooltip>
//                   </Grid>
//                 ))}
//               </Grid>
//             ) : (
//               // List View
//               <MDBox sx={{ maxHeight: "400px", overflowY: "auto" }}>
//                 {filteredIcons.map((icon) => (
//                   <Paper
//                     key={icon}
//                     elevation={value === icon ? 2 : 0}
//                     sx={{
//                       p: 1.5,
//                       mb: 1,
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 2,
//                       cursor: "pointer",
//                       border: value === icon ? "2px solid" : "1px solid",
//                       borderColor:
//                         value === icon ? "primary.main" : "transparent",
//                       bgcolor:
//                         value === icon ? "primary.light" : "background.paper",
//                       "&:hover": {
//                         bgcolor: "action.hover",
//                       },
//                     }}
//                     onClick={() => handleSelectIcon(icon)}
//                   >
//                     <Icon icon={icon} width={24} height={24} />
//                     <MDBox flex={1}>
//                       <Typography variant="body2" fontWeight="medium">
//                         {icon.split(":").pop()}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {icon}
//                       </Typography>
//                     </MDBox>
//                     <IconButton
//                       size="small"
//                       onClick={(e) => toggleFavorite(icon, e)}
//                       sx={{
//                         opacity: favorites.includes(icon) ? 1 : 0.5,
//                       }}
//                     >
//                       {favorites.includes(icon) ? (
//                         <StarIcon color="warning" />
//                       ) : (
//                         <StarIcon />
//                       )}
//                     </IconButton>
//                   </Paper>
//                 ))}
//               </MDBox>
//             )}

//             {filteredIcons.length === 0 && (
//               <MDBox
//                 display="flex"
//                 flexDirection="column"
//                 justifyContent="center"
//                 alignItems="center"
//                 height={200}
//                 gap={2}
//               >
//                 <Icon
//                   icon="mdi:emoticon-sad-outline"
//                   width={64}
//                   height={64}
//                   color="action.disabled"
//                 />
//                 <Typography color="text.secondary">
//                   لم يتم العثور على أيقونات تطابق بحثك
//                 </Typography>
//                 <Button variant="outlined" onClick={() => setSearchTerm("")}>
//                   عرض جميع الأيقونات
//                 </Button>
//               </MDBox>
//             )}
//           </MDBox>
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default IconPicker;

// components/IconPicker.js
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Icon } from "@iconify/react";

// Material UI components
import {
  TextField,
  InputAdornment,
  Box,
  Grid,
  Paper,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  InputBase,
  Typography,
  Tabs,
  Tab,
  Chip,
  FormControlLabel,
  Switch,
  Tooltip,
  CircularProgress,
  Alert,
  Snackbar,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import FavoriteIcon from "@mui/icons-material/Favorite";
import StarIcon from "@mui/icons-material/Star";
import RecentIcon from "@mui/icons-material/History";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import OfflinePinIcon from "@mui/icons-material/OfflinePin";

import MDBox from "components/MDBox";
import { ICONS_BY_CATEGORY } from "./icon";

// Get all local icons for search
const LOCAL_ICONS = Object.values(ICONS_BY_CATEGORY).flat();

// Popular icon prefixes for quick filtering
const POPULAR_PREFIXES = [
  { id: "all", label: "كل المكتبات", icon: "mdi:apps" },
  { id: "mdi", label: "Material Design", icon: "mdi:material-design" },
  { id: "fa", label: "Font Awesome", icon: "fa-brands:font-awesome" },
  { id: "bx", label: "Boxicons", icon: "bx:bxl-github" },
  { id: "tabler", label: "Tabler Icons", icon: "tabler:brand-tabler" },
  { id: "ri", label: "Remix Icon", icon: "ri:remixicon-line" },
  { id: "bi", label: "Bootstrap Icons", icon: "bi:bootstrap-fill" },
  { id: "carbon", label: "Carbon", icon: "carbon:ibm-cloud" },
];

// Categories for local icons
const LOCAL_CATEGORIES = [
  { id: "all", label: "الكل", count: LOCAL_ICONS.length },
  {
    id: "islamic",
    label: "إسلامي",
    count: ICONS_BY_CATEGORY.islamic.length,
    icon: "mdi:mosque",
  },
  {
    id: "donation",
    label: "التبرعات",
    count: ICONS_BY_CATEGORY.donation.length,
    icon: "mdi:heart",
  },
  {
    id: "organization",
    label: "المؤسسة",
    count: ICONS_BY_CATEGORY.organization.length,
    icon: "mdi:office-building",
  },
  {
    id: "social",
    label: "التواصل",
    count: ICONS_BY_CATEGORY.social.length,
    icon: "mdi:share",
  },
];

const IconPicker = ({
  value,
  onChange,
  label = "اختر أيقونة",
  error,
  helperText,
  width = "100%",
  size = "medium",
}) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredIcons, setFilteredIcons] = useState(LOCAL_ICONS);
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedPrefix, setSelectedPrefix] = useState("all");
  const [favorites, setFavorites] = useState([]);
  const [viewMode, setViewMode] = useState("grid");
  const [showNames, setShowNames] = useState(true);
  const [recentIcons, setRecentIcons] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [apiResults, setApiResults] = useState([]);
  const [showOffline, setShowOffline] = useState(false);
  const [searchMode, setSearchMode] = useState("local"); // 'local' or 'api'
  const searchRef = useRef(null);
  const searchTimeout = useRef(null);

  // Load favorites and recent from localStorage
  useEffect(() => {
    const savedFavorites = localStorage.getItem("iconFavorites");
    const savedRecent = localStorage.getItem("iconRecent");

    if (savedFavorites) {
      setFavorites(JSON.parse(savedFavorites));
    }

    if (savedRecent) {
      setRecentIcons(JSON.parse(savedRecent));
    }
  }, []);

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem("iconFavorites", JSON.stringify(favorites));
  }, [favorites]);

  useEffect(() => {
    localStorage.setItem("iconRecent", JSON.stringify(recentIcons));
  }, [recentIcons]);

  // Search Iconify API
  const searchIconifyAPI = useCallback(async (query, prefix = null) => {
    if (!query || query.length < 2) return [];

    try {
      setIsSearching(true);

      // Build search URL
      let url = `https://api.iconify.design/search?query=${encodeURIComponent(
        query
      )}&limit=50`;

      if (prefix && prefix !== "all") {
        url += `&prefix=${prefix}`;
      }

      const response = await fetch(url);
      if (!response.ok) throw new Error("API request failed");

      const data = await response.json();
      return data.icons || [];
    } catch (error) {
      console.error("Iconify API search error:", error);
      setShowOffline(true);
      return [];
    } finally {
      setIsSearching(false);
    }
  }, []);

  // Handle search with debouncing
  useEffect(() => {
    if (searchTerm.trim().length < 2) {
      // Show local icons when search term is short
      let iconsToFilter = LOCAL_ICONS;

      if (activeCategory !== "all" && ICONS_BY_CATEGORY[activeCategory]) {
        iconsToFilter = ICONS_BY_CATEGORY[activeCategory];
      }

      setFilteredIcons(iconsToFilter);
      setSearchMode("local");
      return;
    }

    // Clear previous timeout
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    // Set new timeout for debouncing
    searchTimeout.current = setTimeout(async () => {
      if (searchTerm.trim().length >= 2) {
        setSearchMode("api");
        const apiIcons = await searchIconifyAPI(
          searchTerm,
          selectedPrefix === "all" ? null : selectedPrefix
        );
        setApiResults(apiIcons);

        if (apiIcons.length > 0) {
          setFilteredIcons(apiIcons);
        } else {
          // Fallback to local search if API returns no results
          const localResults = LOCAL_ICONS.filter((icon) =>
            icon.toLowerCase().includes(searchTerm.toLowerCase())
          );
          setFilteredIcons(localResults);
          setSearchMode("local");
        }
      }
    }, 500); // 500ms debounce

    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, [searchTerm, activeCategory, selectedPrefix, searchIconifyAPI]);

  const handleOpen = () => {
    setOpen(true);
    setSearchTerm("");
    setActiveCategory("all");
    setSelectedPrefix("all");
    setSearchMode("local");
    setTimeout(() => {
      if (searchRef.current) {
        searchRef.current.focus();
      }
    }, 100);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectIcon = (icon) => {
    // Add to recent
    const newRecent = [icon, ...recentIcons.filter((i) => i !== icon)].slice(
      0,
      10
    );
    setRecentIcons(newRecent);

    onChange(icon);
    handleClose();
  };

  const handleClear = () => {
    onChange("");
  };

  const toggleFavorite = (icon, e) => {
    e.stopPropagation();
    if (favorites.includes(icon)) {
      setFavorites(favorites.filter((fav) => fav !== icon));
    } else {
      setFavorites([...favorites, icon]);
    }
  };

  const handleCategoryChange = (categoryId) => {
    setActiveCategory(categoryId);
    setSelectedPrefix("all");
    setSearchTerm("");
    setSearchMode("local");

    if (categoryId === "all") {
      setFilteredIcons(LOCAL_ICONS);
    } else if (ICONS_BY_CATEGORY[categoryId]) {
      setFilteredIcons(ICONS_BY_CATEGORY[categoryId]);
    }
  };

  const handlePrefixChange = (prefixId) => {
    setSelectedPrefix(prefixId);
    setActiveCategory("all");
    setSearchTerm("");

    if (prefixId === "all") {
      setFilteredIcons(LOCAL_ICONS);
      setSearchMode("local");
    } else {
      // Filter local icons by prefix
      const filtered = LOCAL_ICONS.filter((icon) =>
        icon.startsWith(`${prefixId}:`)
      );
      setFilteredIcons(filtered);
      setSearchMode("local");
    }
  };

  return (
    <>
      <MDBox width={width}>
        <TextField
          fullWidth
          label={label}
          value={value}
          onClick={handleOpen}
          error={error}
          helperText={helperText}
          InputProps={{
            readOnly: true,
            startAdornment: value ? (
              <InputAdornment position="start">
                <Icon
                  icon={value}
                  width={size === "small" ? 20 : 24}
                  height={size === "small" ? 20 : 24}
                />
              </InputAdornment>
            ) : null,
            endAdornment: (
              <InputAdornment position="end">
                {value ? (
                  <IconButton size="small" onClick={handleClear}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                ) : (
                  <IconButton size="small" onClick={handleOpen}>
                    <SearchIcon />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
          size={size}
          sx={{
            cursor: "pointer",
            "& .MuiInputBase-input": {
              cursor: "pointer",
            },
          }}
        />
      </MDBox>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            height: "85vh",
            maxHeight: "800px",
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <GridViewIcon />
              محدد الأيقونات
              <Chip
                size="small"
                icon={
                  searchMode === "api" ? (
                    <OnlinePredictionIcon />
                  ) : (
                    <OfflinePinIcon />
                  )
                }
                label={searchMode === "api" ? "بحث مباشر" : "محلي"}
                color={searchMode === "api" ? "success" : "default"}
                variant="outlined"
                sx={{ ml: 1 }}
              />
            </Typography>
            <MDBox display="flex" gap={1} alignItems="center">
              <Tooltip title="عرض الأسماء">
                <FormControlLabel
                  control={
                    <Switch
                      size="small"
                      checked={showNames}
                      onChange={(e) => setShowNames(e.target.checked)}
                    />
                  }
                  label=""
                />
              </Tooltip>
              <Tooltip title="عرض شبكة">
                <IconButton
                  size="small"
                  color={viewMode === "grid" ? "primary" : "default"}
                  onClick={() => setViewMode("grid")}
                >
                  <GridViewIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="عرض قائمة">
                <IconButton
                  size="small"
                  color={viewMode === "list" ? "primary" : "default"}
                  onClick={() => setViewMode("list")}
                >
                  <ListIcon />
                </IconButton>
              </Tooltip>
              <IconButton onClick={handleClose} size="small">
                <CloseIcon />
              </IconButton>
            </MDBox>
          </MDBox>

          <MDBox mt={2}>
            <InputBase
              fullWidth
              placeholder="ابحث عن أيقونة (اكتب كلمتين على الأقل للبحث من الإنترنت)..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              inputRef={searchRef}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
              endAdornment={
                isSearching && (
                  <InputAdornment position="end">
                    <CircularProgress size={20} />
                  </InputAdornment>
                )
              }
              sx={{
                bgcolor: "background.paper",
                borderRadius: 2,
                px: 2,
                py: 1.5,
                border: "2px solid",
                borderColor: "primary.light",
                "&:focus-within": {
                  borderColor: "primary.main",
                },
              }}
            />
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 1, display: "block" }}
            >
              {searchTerm.length < 2
                ? "اكتب كلمتين على الأقل للبحث من مكتبة Iconify"
                : `البحث عن: "${searchTerm}"`}
            </Typography>
          </MDBox>

          {/* Tabs for filtering */}
          <MDBox mt={2} sx={{ overflowX: "auto", pb: 1 }}>
            <MDBox display="flex" gap={0.5} sx={{ minWidth: "max-content" }}>
              {searchTerm.length < 2 ? (
                // Show categories when not searching
                <>
                  <Typography
                    variant="body2"
                    sx={{ mr: 1, alignSelf: "center" }}
                  >
                    التصنيفات:
                  </Typography>
                  {LOCAL_CATEGORIES.map((category) => (
                    <Chip
                      key={category.id}
                      label={`${category.label} (${category.count})`}
                      onClick={() => handleCategoryChange(category.id)}
                      color={
                        activeCategory === category.id ? "primary" : "default"
                      }
                      variant={
                        activeCategory === category.id ? "filled" : "outlined"
                      }
                      icon={
                        category.icon ? (
                          <Icon icon={category.icon} width={16} height={16} />
                        ) : undefined
                      }
                      size="small"
                      sx={{
                        borderRadius: 1.5,
                        fontWeight:
                          activeCategory === category.id ? "bold" : "normal",
                      }}
                    />
                  ))}
                </>
              ) : (
                // Show icon libraries when searching
                <>
                  <Typography
                    variant="body2"
                    sx={{ mr: 1, alignSelf: "center" }}
                  >
                    المكتبات:
                  </Typography>
                  {POPULAR_PREFIXES.map((prefix) => (
                    <Chip
                      key={prefix.id}
                      label={prefix.label}
                      onClick={() => handlePrefixChange(prefix.id)}
                      color={
                        selectedPrefix === prefix.id ? "primary" : "default"
                      }
                      variant={
                        selectedPrefix === prefix.id ? "filled" : "outlined"
                      }
                      icon={<Icon icon={prefix.icon} width={16} height={16} />}
                      size="small"
                      sx={{
                        borderRadius: 1.5,
                        fontWeight:
                          selectedPrefix === prefix.id ? "bold" : "normal",
                      }}
                    />
                  ))}
                </>
              )}
            </MDBox>
          </MDBox>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2 }}>
          {/* Recent Icons */}
          {recentIcons.length > 0 && searchTerm.length < 2 && (
            <MDBox mb={3}>
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "primary.main",
                }}
              >
                <RecentIcon fontSize="small" />
                <span>الأيقونات المستخدمة مؤخراً</span>
              </Typography>
              <Grid container spacing={1}>
                {recentIcons.map((icon) => (
                  <Grid item xs={viewMode === "grid" ? 2 : 12} key={icon}>
                    <Paper
                      elevation={value === icon ? 3 : 1}
                      sx={{
                        p: viewMode === "grid" ? 1.5 : 1,
                        display: "flex",
                        flexDirection: viewMode === "grid" ? "column" : "row",
                        alignItems: "center",
                        justifyContent:
                          viewMode === "grid" ? "center" : "flex-start",
                        cursor: "pointer",
                        height: "100%",
                        minHeight: viewMode === "grid" ? "70px" : "auto",
                        border: value === icon ? "2px solid" : "1px solid",
                        borderColor:
                          value === icon ? "primary.main" : "divider",
                        bgcolor:
                          value === icon ? "primary.light" : "background.paper",
                        "&:hover": {
                          bgcolor: "action.hover",
                          transform: "scale(1.02)",
                          transition: "transform 0.2s",
                        },
                        gap: viewMode === "list" ? 2 : 0,
                      }}
                      onClick={() => handleSelectIcon(icon)}
                    >
                      <MDBox
                        position="relative"
                        display="flex"
                        alignItems="center"
                      >
                        <Icon
                          icon={icon}
                          width={viewMode === "grid" ? 20 : 24}
                          height={viewMode === "grid" ? 20 : 24}
                        />
                        <IconButton
                          size="small"
                          onClick={(e) => toggleFavorite(icon, e)}
                          sx={{
                            position:
                              viewMode === "grid" ? "absolute" : "relative",
                            top: viewMode === "grid" ? -8 : 0,
                            right: viewMode === "grid" ? -8 : 0,
                            bgcolor: "background.paper",
                            width: 20,
                            height: 20,
                            opacity: 0.8,
                            "&:hover": {
                              opacity: 1,
                            },
                          }}
                        >
                          {favorites.includes(icon) ? (
                            <StarIcon fontSize="small" color="warning" />
                          ) : (
                            <StarIcon fontSize="small" />
                          )}
                        </IconButton>
                      </MDBox>
                      {showNames && (
                        <MDBox
                          textAlign={viewMode === "grid" ? "center" : "left"}
                          flex={1}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              display: "block",
                              wordBreak: "break-word",
                              fontSize:
                                viewMode === "grid" ? "0.55rem" : "0.75rem",
                              fontWeight:
                                viewMode === "list" ? "medium" : "normal",
                            }}
                          >
                            {icon.split(":").pop()}
                          </Typography>
                          {viewMode === "list" && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{
                                fontSize: "0.65rem",
                              }}
                            >
                              {icon}
                            </Typography>
                          )}
                        </MDBox>
                      )}
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </MDBox>
          )}

          {/* Favorites */}
          {favorites.length > 0 && searchTerm.length < 2 && (
            <MDBox mb={3}>
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "warning.main",
                }}
              >
                <StarIcon fontSize="small" />
                <span>المفضلة ({favorites.length})</span>
              </Typography>
              <Grid container spacing={1}>
                {favorites.map((icon) => (
                  <Grid item xs={viewMode === "grid" ? 2 : 12} key={icon}>
                    <Paper
                      elevation={value === icon ? 3 : 1}
                      sx={{
                        p: viewMode === "grid" ? 1.5 : 1,
                        display: "flex",
                        flexDirection: viewMode === "grid" ? "column" : "row",
                        alignItems: "center",
                        justifyContent:
                          viewMode === "grid" ? "center" : "flex-start",
                        cursor: "pointer",
                        height: "100%",
                        minHeight: viewMode === "grid" ? "70px" : "auto",
                        border: value === icon ? "2px solid" : "1px solid",
                        borderColor:
                          value === icon ? "primary.main" : "divider",
                        bgcolor:
                          value === icon ? "primary.light" : "background.paper",
                        "&:hover": {
                          bgcolor: "action.hover",
                          transform: "scale(1.02)",
                          transition: "transform 0.2s",
                        },
                        gap: viewMode === "list" ? 2 : 0,
                      }}
                      onClick={() => handleSelectIcon(icon)}
                    >
                      <MDBox
                        position="relative"
                        display="flex"
                        alignItems="center"
                      >
                        <Icon
                          icon={icon}
                          width={viewMode === "grid" ? 20 : 24}
                          height={viewMode === "grid" ? 20 : 24}
                        />
                        <IconButton
                          size="small"
                          onClick={(e) => toggleFavorite(icon, e)}
                          sx={{
                            position:
                              viewMode === "grid" ? "absolute" : "relative",
                            top: viewMode === "grid" ? -8 : 0,
                            right: viewMode === "grid" ? -8 : 0,
                            bgcolor: "background.paper",
                            width: 20,
                            height: 20,
                            opacity: 0.8,
                            "&:hover": {
                              opacity: 1,
                            },
                          }}
                        >
                          <StarIcon fontSize="small" color="warning" />
                        </IconButton>
                      </MDBox>
                      {showNames && (
                        <MDBox
                          textAlign={viewMode === "grid" ? "center" : "left"}
                          flex={1}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              display: "block",
                              wordBreak: "break-word",
                              fontSize:
                                viewMode === "grid" ? "0.55rem" : "0.75rem",
                              fontWeight:
                                viewMode === "list" ? "medium" : "normal",
                            }}
                          >
                            {icon.split(":").pop()}
                          </Typography>
                          {viewMode === "list" && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{
                                fontSize: "0.65rem",
                              }}
                            >
                              {icon}
                            </Typography>
                          )}
                        </MDBox>
                      )}
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </MDBox>
          )}

          {/* Main Icons */}
          <MDBox>
            <Typography variant="subtitle1" gutterBottom>
              {searchTerm.length >= 2 ? (
                <>
                  نتائج البحث
                  {selectedPrefix !== "all" && ` (${selectedPrefix})`}
                </>
              ) : activeCategory === "all" ? (
                "جميع الأيقونات"
              ) : (
                LOCAL_CATEGORIES.find((c) => c.id === activeCategory)?.label
              )}
              <Typography
                component="span"
                color="text.secondary"
                sx={{ ml: 1 }}
              >
                ({filteredIcons.length} أيقونة)
              </Typography>
            </Typography>

            {isSearching ? (
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                height={200}
              >
                <CircularProgress />
                <Typography sx={{ ml: 2 }}>
                  جاري البحث في مكتبة الأيقونات...
                </Typography>
              </MDBox>
            ) : viewMode === "grid" ? (
              <Grid container spacing={1}>
                {filteredIcons.map((icon) => (
                  <Grid item xs={3} sm={2} md={1.5} key={icon}>
                    <Tooltip title={icon} placement="top">
                      <Paper
                        elevation={value === icon ? 3 : 1}
                        sx={{
                          p: 1.5,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          height: "100%",
                          minHeight: "70px",
                          border: value === icon ? "2px solid" : "1px solid",
                          borderColor:
                            value === icon ? "primary.main" : "divider",
                          bgcolor:
                            value === icon
                              ? "primary.light"
                              : "background.paper",
                          "&:hover": {
                            bgcolor: "action.hover",
                            transform: "scale(1.05)",
                            transition: "transform 0.2s",
                            boxShadow: 3,
                          },
                        }}
                        onClick={() => handleSelectIcon(icon)}
                      >
                        <MDBox position="relative">
                          <Icon icon={icon} width={20} height={20} />
                          <IconButton
                            size="small"
                            onClick={(e) => toggleFavorite(icon, e)}
                            sx={{
                              position: "absolute",
                              top: -8,
                              right: -8,
                              bgcolor: "background.paper",
                              width: 20,
                              height: 20,
                              opacity: 0,
                              "&:hover": {
                                opacity: 1,
                              },
                              "&.MuiIconButton-root:hover": {
                                bgcolor: "background.paper",
                              },
                            }}
                          >
                            {favorites.includes(icon) ? (
                              <StarIcon fontSize="small" color="warning" />
                            ) : (
                              <StarIcon fontSize="small" />
                            )}
                          </IconButton>
                        </MDBox>
                        {showNames && (
                          <Typography
                            variant="caption"
                            sx={{
                              mt: 0.5,
                              textAlign: "center",
                              wordBreak: "break-word",
                              fontSize: "0.55rem",
                              lineHeight: 1.2,
                            }}
                          >
                            {icon.split(":").pop()}
                          </Typography>
                        )}
                      </Paper>
                    </Tooltip>
                  </Grid>
                ))}
              </Grid>
            ) : (
              // List View
              <MDBox sx={{ maxHeight: "400px", overflowY: "auto" }}>
                {filteredIcons.map((icon) => (
                  <Paper
                    key={icon}
                    elevation={value === icon ? 2 : 0}
                    sx={{
                      p: 1.5,
                      mb: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      cursor: "pointer",
                      border: value === icon ? "2px solid" : "1px solid",
                      borderColor:
                        value === icon ? "primary.main" : "transparent",
                      bgcolor:
                        value === icon ? "primary.light" : "background.paper",
                      "&:hover": {
                        bgcolor: "action.hover",
                      },
                    }}
                    onClick={() => handleSelectIcon(icon)}
                  >
                    <Icon icon={icon} width={24} height={24} />
                    <MDBox flex={1}>
                      <Typography variant="body2" fontWeight="medium">
                        {icon.split(":").pop()}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {icon}
                      </Typography>
                    </MDBox>
                    <IconButton
                      size="small"
                      onClick={(e) => toggleFavorite(icon, e)}
                      sx={{
                        opacity: favorites.includes(icon) ? 1 : 0.5,
                      }}
                    >
                      {favorites.includes(icon) ? (
                        <StarIcon color="warning" />
                      ) : (
                        <StarIcon />
                      )}
                    </IconButton>
                  </Paper>
                ))}
              </MDBox>
            )}

            {filteredIcons.length === 0 && !isSearching && (
              <MDBox
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height={200}
                gap={2}
              >
                <Icon
                  icon="mdi:emoticon-sad-outline"
                  width={64}
                  height={64}
                  color="action.disabled"
                />
                <Typography color="text.secondary">
                  لم يتم العثور على أيقونات تطابق بحثك
                </Typography>
                {searchTerm.length >= 2 && (
                  <Button variant="outlined" onClick={() => setSearchTerm("")}>
                    العودة إلى الأيقونات المحلية
                  </Button>
                )}
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={showOffline}
        autoHideDuration={6000}
        onClose={() => setShowOffline(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="warning"
          onClose={() => setShowOffline(false)}
          sx={{ width: "100%" }}
        >
          تعذر الاتصال بمكتبة الأيقونات. جاري استخدام الأيقونات المحلية.
        </Alert>
      </Snackbar>
    </>
  );
};

export default IconPicker;
